import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
        this.smoothScroll();
        this.nextBlockScroll();
    }

    onScroll() {
        const overlayElm = document.querySelectorAll(".js-scrolloverlay");
        const revealElm = document.querySelectorAll(".js-scrollreveal");

        overlayElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top center",
                end: "60% top",
                onUpdate: ({ progress, direction, isActive }) => {
                    if (isActive) {
                        el.classList.add("-reveal");
                        const tgt = el.getAttribute("data-overlay");
                        const tgtoverlay = document.querySelector(`.${tgt}__overlay`);
                        const tgtoverlay__obj = document.querySelector(`.${tgt}__overlay__obj`);
                        tgtoverlay.classList.add("-active");
                        tgtoverlay__obj.style.transform = `translate(0,-${progress * 500}px)`;
                    } else {
                        const others = document.querySelectorAll(`.js-overlay`);
                        others.forEach((el) => el.classList.remove("-active"));
                    }
                },
                //markers: true,
            });
        });

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 70%",
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll(".js-smoothscroll");

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = window.innerWidth <= 768 ? window.innerWidth * 0.3 : 200 * (window.innerWidth / 1920);
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });
    }

    nextBlockScroll() {
        const trigger = document.querySelectorAll(".js-nextblockscroll");
        let hasScrolled = false;

        const gotoSection = (section) => {
            if (hasScrolled) {
                //gsap.to(window, { duration: 2, scrollTo: { y: section, offsetY: 0 }, ease: "circ.inOut" });
                gsap.to(window, { duration: 2, scrollTo: { y: section } });

                document.querySelector(".js-blockscrollanim").classList.add("fire-blockscrollanim");

                setTimeout(() => {
                    document.querySelector(".js-blockscrollanim").classList.remove("fire-blockscrollanim");
                }, 3000);
            }
        };

        // Change state when first scrolled
        window.addEventListener("scroll", () => (hasScrolled = true), { once: true });

        trigger.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top top",
                onEnter: () => {
                    const tgt = el.getAttribute("data-target");
                    gotoSection("#" + tgt);
                },
                //markers: true,
            });
        });
    }
}
